export const HS_MONITOR_OVERALL_PROGRESS = {
  EDUCATOR_PRACTICES: 'Educator Practices',
  SCHOOLWIDE_PRACTICES: 'Schoolwide Practices',
  STUDENT_ACTIVITES: 'Student Activities',
  K8_TIER2_GRADE_BAND: 'K-8 Tier 2 Grade Band',
}

export const HS_MONITOR_PRACTICE_TITLES = {
  'Educator Practices': 'Educator Practice Marked Done',
  'Schoolwide Practices': 'Schoolwide Practice Marked Done',
  'Student Activities': 'Student Activities by Grade',
  'K-8 Tier 2 Grade Band': 'Lessons Completed by Unit',
}

export const UNIT_NAMES = [
  'Emotions, Thoughts & Feelings',
  'Relationship & Prosocial Skills',
  'Executive Functioning',
]
